import { BreadcrumbsModel } from '../../types/Breadcrumbs/BreadcrumbsModel';

export const siteBodyBreadcrumbs = () : BreadcrumbsModel[] => ([
    {
        key: '1',
        value: 'Настройка главной',
        url: '',
    },
    {
        key: '2',
        value: 'Body сайта',
        url: '',
    },
]);
